/** @jsx h */
import { h } from 'preact'

const HealthNutrition = () => (
  <svg width={28} height={32}>
    <g fill='none' fillRule='evenodd'>
      <path
        stroke='#2F3A4A'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14 30.015c-6 2.189-12-6.511-12-15 0-7.547 8-8 12-6 4-2 12-1.547 12 6 0 8.489-6 17.189-12 15z'
      />
      <path
        stroke='#2F3A4A'
        strokeLinejoin='round'
        d='M17 2c-2 .667-3 2.333-3 5'
      />
      <path stroke='#2F3A4A' d='M6 3c0-1 4-2 6 2 1 2-6-1-6-2z' />
      <path
        fill='#2F3A4A'
        fillRule='nonzero'
        d='M11 10.5v1c-.512 0-.73 0-.992.005l-.016-1c.27-.004.49-.005 1.008-.005zm-2.04.051l.082.997a6.051 6.051 0 0 0-.914.136l-.233-.972c.32-.077.668-.128 1.065-.16zm-2.173.598l.51.86c-.234.139-.438.316-.619.54l-.779-.627c.255-.317.55-.572.888-.773zM5.296 12.95l.92.392c-.11.257-.206.548-.29.877l-.97-.247c.097-.377.21-.717.34-1.022zm-.54 2.008l.987.159c-.048.297-.089.617-.122.961l-.995-.097c.035-.364.078-.705.13-1.023zm-.21 2.088l1 .053c-.017.311-.029.639-.036.984l-1-.022c.008-.355.02-.693.037-1.015z'
      />
    </g>
  </svg>
)

export default HealthNutrition
